<!-- <div class="div-25"> -->
<form [formGroup]="reportForm">


    <div class="div-17" *ngIf="datePickerVisible===true">

        <div class="mx-2">
            <div class="div-19">
                <div class="div-20">From</div>
                <!-- <img loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/4bbf3f6be6b4a0c4435de1895467800e2ddd5d0433d0ed53d3fd76dd73608aab?"
              class="img-7" /> -->
            </div>
            <div class="div-21">
                <Input type="date" (change)="setFromDate($event)" onkeydown="return false" placeholder="Select Date"
                    style="border: 0px solid transparent;" />
            </div>
        </div>
        <div class="mx-2">
            <div class="div-24">
                <div class="div-25">To</div>
                <!-- <img loading="lazy"
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/4bbf3f6be6b4a0c4435de1895467800e2ddd5d0433d0ed53d3fd76dd73608aab?"
              class="img-9" /> -->
            </div>
            <div class="div-1" style="display: flex;">
                <Input type="date" (change)="setToDate($event)" onkeydown="return false" placeholder="Select Date"
                    style="border: 0px solid transparent;" /><br />
            </div>

        </div>


        <div class="mx-2">
            <button (click)="customOkClick()" class="div-customOkClick mt-4">Go</button>
        </div>
        <!-- <span>
        </span> -->
    </div>
    <div class="date-filter text-end">
        <div>

            <button type="button" class="btn me-3"
                [ngClass]="{'btn-primary': activeButton === '1D', 'btn-secondary': activeButton !== '1D'}"
                (click)="setActiveButton('1D')">
                1D
            </button>
            <button type="button" class="btn me-3"
                [ngClass]="{'btn-primary': activeButton === '1W', 'btn-secondary': activeButton !== '1W'}"
                (click)="setActiveButton('1W')">
                1W
            </button>
            <button type="button" class="btn me-3"
                [ngClass]="{'btn-primary': activeButton === '1M', 'btn-secondary': activeButton !== '1M'}"
                (click)="setActiveButton('1M')">
                1M
            </button>
            <button type="button" class="btn"
                [ngClass]="{'btn-primary': activeButton === '3M', 'btn-secondary': activeButton !== '3M'}"
                (click)="setActiveButton('3M')">
                3M
            </button>
        </div>
    </div>


    <div class="row mt-4">
        <div class="col-xl-3 col-md-6 mt-4 active_deals">
            <div class="card">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 ">
                            <p class="text-uppercase fw-medium  mb-0"> {{placeHolders['LBL_ACTIVE_DEALS']}}<small
                                    class="fw-light text-lowercase">({{placeHolders['LBL_AS_OF_NOW']}})</small></p>
                        </div>


                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold mb-4">{{active_deals}}</h4>
                        </div>
                        <div class="flex-shrink-0">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                class="text-muted " fill="white">
                                <path
                                    d="M19.0001 14V17H22.0001V19H18.9991L19.0001 22H17.0001L16.9991 19H14.0001V17H17.0001V14H19.0001ZM20.2426 4.75748C22.505 7.02453 22.5829 10.6361 20.4795 12.9921L19.06 11.5741C20.3901 10.05 20.3201 7.66 18.827 6.17022C17.3244 4.67104 14.9076 4.60713 13.337 6.017L12.0019 7.21536L10.6661 6.01793C9.09098 4.60609 6.67506 4.66821 5.17157 6.1717C3.68183 7.66143 3.60704 10.0474 4.97993 11.6233L13.412 20.0691L11.9999 21.4851L3.52138 12.9931C1.41705 10.6371 1.49571 7.01913 3.75736 4.75748C6.02157 2.49327 9.64519 2.41699 12.001 4.52865C14.35 2.42012 17.98 2.49012 20.2426 4.75748Z">
                                </path>
                            </svg> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="3em" fill="none"  height="3em" viewBox="0 0 24 24"><g stroke="currentColor" stroke-linecap="round" stroke-linejoin="round" stroke-width="1.5" color="currentColor"><path d="M7.729 15.286h5m-2.502-2.5h.01m-.008 5h.01M6.5 3.697C9.533 6.782 14.536.124 17.496 2.54C19.199 3.93 18.66 7 16.449 9"/><path d="M18.664 6.578c.983.179 1.204.765 1.497 2.392c.265 1.466.339 3.225.339 3.974a1.3 1.3 0 0 1-.338.743c-2.057 2.035-6.137 5.878-8.196 7.787c-.808.681-2.028.696-2.886.07c-1.756-1.491-3.443-3.178-5.097-4.701c-.664-.808-.648-1.956.076-2.717c2.178-2.135 6.12-5.789 8.346-7.807c.223-.18.496-.294.79-.319c.498 0 1.355.063 2.19.109"/></g></svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-3 col-md-6 mt-4">

            <div class="card ">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 ">
                            <p class="text-uppercase fw-medium text-muted  mb-0">{{placeHolders['LBL_IMPRESSIONS']}}</p>
                        </div>


                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">{{impressions}}</h4>

                        </div>
                        <div class="flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                class="text-muted " fill="rgba(135,138,155,1)">
                                <path
                                    d="M12.0003 3C17.3924 3 21.8784 6.87976 22.8189 12C21.8784 17.1202 17.3924 21 12.0003 21C6.60812 21 2.12215 17.1202 1.18164 12C2.12215 6.87976 6.60812 3 12.0003 3ZM12.0003 19C16.2359 19 19.8603 16.052 20.7777 12C19.8603 7.94803 16.2359 5 12.0003 5C7.7646 5 4.14022 7.94803 3.22278 12C4.14022 16.052 7.7646 19 12.0003 19ZM12.0003 16.5C9.51498 16.5 7.50026 14.4853 7.50026 12C7.50026 9.51472 9.51498 7.5 12.0003 7.5C14.4855 7.5 16.5003 9.51472 16.5003 12C16.5003 14.4853 14.4855 16.5 12.0003 16.5ZM12.0003 14.5C13.381 14.5 14.5003 13.3807 14.5003 12C14.5003 10.6193 13.381 9.5 12.0003 9.5C10.6196 9.5 9.50026 10.6193 9.50026 12C9.50026 13.3807 10.6196 14.5 12.0003 14.5Z">
                                </path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-3 col-md-6  mt-4">

            <div class="card ">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 ">
                            <p class="text-uppercase fw-medium text-muted  mb-0">{{placeHolders['LBL_REACH']}}</p>
                        </div>


                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">{{reach}}</h4>

                        </div>
                        <div class=" flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                class="text-muted " fill="rgba(135,138,155,1)">
                                <path
                                    d="M5 3V19H21V21H3V3H5ZM20.2929 6.29289L21.7071 7.70711L16 13.4142L13 10.415L8.70711 14.7071L7.29289 13.2929L13 7.58579L16 10.585L20.2929 6.29289Z">
                                </path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="col-xl-3 col-md-6   mt-4">

            <div class="card ">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 ">
                            <p class="text-uppercase fw-medium text-muted  mb-0">{{placeHolders['LBL_CLICKS']}}</p>
                        </div>

                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">{{clicks}}</h4>

                        </div>
                        <div class="flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                class="text-muted " fill="rgba(135,138,155,1)">
                                <path
                                    d="M11.1411 4C9.5587 4 8.75361 4.16876 8.01266 4.56502C7.38342 4.90155 6.90155 5.38342 6.56502 6.01266C6.16876 6.75361 6 7.5587 6 9.14111V14.8589C6 16.4413 6.16876 17.2464 6.56502 17.9873C6.90155 18.6166 7.38342 19.0985 8.01266 19.435C8.75361 19.8312 9.5587 20 11.1411 20H12.8589C14.4413 20 15.2464 19.8312 15.9873 19.435C16.6166 19.0985 17.0985 18.6166 17.435 17.9873C17.8312 17.2464 18 16.4413 18 14.8589V9.14111C18 7.5587 17.8312 6.75361 17.435 6.01266C17.0985 5.38342 16.6166 4.90155 15.9873 4.56502C15.2464 4.16876 14.4413 4 12.8589 4H11.1411ZM11.1411 2H12.8589C14.8728 2 15.9528 2.27848 16.9305 2.8014C17.9083 3.32432 18.6757 4.09169 19.1986 5.06946C19.7215 6.04724 20 7.12721 20 9.14111V14.8589C20 16.8728 19.7215 17.9528 19.1986 18.9305C18.6757 19.9083 17.9083 20.6757 16.9305 21.1986C15.9528 21.7215 14.8728 22 12.8589 22H11.1411C9.12721 22 8.04724 21.7215 7.06946 21.1986C6.09169 20.6757 5.32432 19.9083 4.8014 18.9305C4.27848 17.9528 4 16.8728 4 14.8589V9.14111C4 7.12721 4.27848 6.04724 4.8014 5.06946C5.32432 4.09169 6.09169 3.32432 7.06946 2.8014C8.04724 2.27848 9.12721 2 11.1411 2ZM11 6H13V11H11V6Z">
                                </path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-md-6  mt-4">

            <div class="card ">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 ">
                            <p class="text-uppercase fw-medium text-muted  mb-0">{{placeHolders['LBL_DEALS_CLAIMED']}}</p>
                        </div>


                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">{{deals_claimed}}</h4>

                        </div>
                        <div class=" flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                fill="rgba(135,138,155,1)">
                                <path
                                    d="M2.00488 9.49979V3.99979C2.00488 3.4475 2.4526 2.99979 3.00488 2.99979H21.0049C21.5572 2.99979 22.0049 3.4475 22.0049 3.99979V9.49979C20.6242 9.49979 19.5049 10.6191 19.5049 11.9998C19.5049 13.3805 20.6242 14.4998 22.0049 14.4998V19.9998C22.0049 20.5521 21.5572 20.9998 21.0049 20.9998H3.00488C2.4526 20.9998 2.00488 20.5521 2.00488 19.9998V14.4998C3.38559 14.4998 4.50488 13.3805 4.50488 11.9998C4.50488 10.6191 3.38559 9.49979 2.00488 9.49979ZM4.00488 7.96755C5.4866 8.7039 6.50488 10.2329 6.50488 11.9998C6.50488 13.7666 5.4866 15.2957 4.00488 16.032V18.9998H20.0049V16.032C18.5232 15.2957 17.5049 13.7666 17.5049 11.9998C17.5049 10.2329 18.5232 8.7039 20.0049 7.96755V4.99979H4.00488V7.96755ZM9.00488 8.99979H15.0049V10.9998H9.00488V8.99979ZM9.00488 12.9998H15.0049V14.9998H9.00488V12.9998Z">
                                </path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-md-6   mt-4">

            <div class="card ">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 ">
                            <p class="text-uppercase fw-medium text-muted  mb-0">{{placeHolders['LBL_FAVORITE']}}</p>
                        </div>


                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">{{deals_favourite}}</h4>

                        </div>
                        <div class="flex-shrink-0">
                            <!-- <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                fill="rgba(135,138,155,1)">
                                <path
                                    d="M15.0049 2.00281C17.214 2.00281 19.0049 3.79367 19.0049 6.00281C19.0049 6.73184 18.8098 7.41532 18.4691 8.00392L23.0049 8.00281V10.0028H21.0049V20.0028C21.0049 20.5551 20.5572 21.0028 20.0049 21.0028H4.00488C3.4526 21.0028 3.00488 20.5551 3.00488 20.0028V10.0028H1.00488V8.00281L5.54065 8.00392C5.19992 7.41532 5.00488 6.73184 5.00488 6.00281C5.00488 3.79367 6.79574 2.00281 9.00488 2.00281C10.2001 2.00281 11.2729 2.52702 12.0058 3.35807C12.7369 2.52702 13.8097 2.00281 15.0049 2.00281ZM11.0049 10.0028H5.00488V19.0028H11.0049V10.0028ZM19.0049 10.0028H13.0049V19.0028H19.0049V10.0028ZM9.00488 4.00281C7.90031 4.00281 7.00488 4.89824 7.00488 6.00281C7.00488 7.05717 7.82076 7.92097 8.85562 7.99732L9.00488 8.00281H11.0049V6.00281C11.0049 5.00116 10.2686 4.1715 9.30766 4.02558L9.15415 4.00829L9.00488 4.00281ZM15.0049 4.00281C13.9505 4.00281 13.0867 4.81869 13.0104 5.85355L13.0049 6.00281V8.00281H15.0049C16.0592 8.00281 16.923 7.18693 16.9994 6.15207L17.0049 6.00281C17.0049 4.89824 16.1095 4.00281 15.0049 4.00281Z">
                                </path>
                            </svg> -->
                            <svg xmlns="http://www.w3.org/2000/svg" width="3em" height="3em" viewBox="0 0 24 24" fill="rgba(135,138,155,1)" ><path  d="M5.911 6.964c1.524-1.6 3.697-1.55 5.189-.253a1.375 1.375 0 0 0 1.796 0c1.491-1.298 3.666-1.346 5.188.253c.887 1.133 1.196 2.178 1.164 3.137c-.033.982-.426 1.958-1.086 2.922c-1.335 1.953-3.624 3.67-5.557 5.033a1.05 1.05 0 0 1-1.214 0c-1.919-1.356-4.208-3.074-5.547-5.028c-.661-.966-1.057-1.944-1.091-2.926c-.035-.96.272-2.006 1.158-3.138m6.087-1.458C9.933 3.782 6.88 3.74 4.796 5.96l-.022.024l-.02.025c-1.09 1.38-1.55 2.775-1.5 4.146c.048 1.355.59 2.606 1.353 3.72c1.511 2.208 4.02 4.065 5.918 5.406c.885.625 2.06.625 2.945.001c1.911-1.348 4.422-3.206 5.93-5.412c.762-1.114 1.301-2.364 1.347-3.718c.046-1.37-.416-2.763-1.506-4.143l-.02-.025l-.022-.024c-2.083-2.22-5.138-2.178-7.201-.454"/></svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-md-6  mt-4">

            <div class="card ">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 ">
                            <p class="text-uppercase fw-medium text-muted  mb-0">{{placeHolders['LBL_CTR']}}</p>
                        </div>



                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">{{ctr}}</h4>

                        </div>
                        <div class="flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                fill="rgba(135,138,155,1)">
                                <path
                                    d="M10.0544 2.0941C11.1756 1.13856 12.8248 1.13855 13.9461 2.09411L15.2941 3.24286C15.4542 3.37935 15.6533 3.46182 15.8631 3.47856L17.6286 3.61945C19.0971 3.73663 20.2633 4.9028 20.3805 6.37131L20.5214 8.13679C20.5381 8.34654 20.6205 8.54568 20.757 8.70585L21.9058 10.0539C22.8614 11.1751 22.8614 12.8243 21.9058 13.9456L20.757 15.2935C20.6206 15.4537 20.538 15.6529 20.5213 15.8627L20.3805 17.6281C20.2633 19.0967 19.0971 20.2628 17.6286 20.3799L15.8631 20.5208C15.6533 20.5376 15.4542 20.6201 15.2941 20.7566L13.9461 21.9053C12.8248 22.8609 11.1756 22.8608 10.0543 21.9053L8.70631 20.7566C8.54615 20.6201 8.34705 20.5376 8.1373 20.5209L6.37184 20.3799C4.9033 20.2627 3.73716 19.0966 3.61997 17.6281L3.47906 15.8627C3.46232 15.6529 3.37983 15.4538 3.24336 15.2936L2.0946 13.9455C1.13905 12.8243 1.13904 11.1752 2.09458 10.0539L3.24334 8.70589C3.37983 8.54573 3.46234 8.34654 3.47907 8.13678L3.61996 6.3713C3.73714 4.90278 4.90327 3.73665 6.3718 3.61946L8.13729 3.47857C8.34705 3.46183 8.54619 3.37935 8.70636 3.24286L10.0544 2.0941ZM12.6488 3.61632C12.2751 3.29782 11.7253 3.29781 11.3516 3.61632L10.0036 4.76509C9.5231 5.17456 8.92568 5.42201 8.29637 5.47223L6.5309 5.61312C6.04139 5.65219 5.65268 6.04089 5.61362 6.53041L5.47272 8.29593C5.4225 8.92521 5.17505 9.52259 4.76559 10.0031L3.61683 11.3511C3.29832 11.7248 3.29831 12.2746 3.61683 12.6483L4.76559 13.9963C5.17506 14.4768 5.4225 15.0743 5.47275 15.7035L5.61363 17.469C5.65268 17.9585 6.04139 18.3473 6.53092 18.3863L8.29636 18.5272C8.92563 18.5774 9.5231 18.8249 10.0036 19.2344L11.3516 20.3831C11.7254 20.7016 12.2751 20.7016 12.6488 20.3831L13.9969 19.2343C14.4773 18.8249 15.0747 18.5774 15.704 18.5272L17.4695 18.3863C17.959 18.3472 18.3478 17.9585 18.3868 17.469L18.5277 15.7035C18.5779 15.0742 18.8253 14.4768 19.2349 13.9964L20.3836 12.6483C20.7022 12.2746 20.7021 11.7249 20.3836 11.3511L19.2348 10.0031C18.8253 9.52259 18.5779 8.92519 18.5277 8.2959L18.3868 6.53041C18.3478 6.0409 17.959 5.65219 17.4695 5.61312L15.704 5.47224C15.0748 5.42203 14.4773 5.17455 13.9968 4.76508L12.6488 3.61632ZM14.8284 7.75718L16.2426 9.1714L9.17154 16.2425L7.75733 14.8282L14.8284 7.75718ZM10.2322 10.232C9.64641 10.8178 8.69667 10.8178 8.11088 10.232C7.52509 9.6463 7.52509 8.69652 8.11088 8.11073C8.69667 7.52494 9.64641 7.52494 10.2322 8.11073C10.818 8.69652 10.818 9.6463 10.2322 10.232ZM13.7677 15.8889C14.3535 16.4747 15.3032 16.4747 15.889 15.8889C16.4748 15.3031 16.4748 14.3534 15.889 13.7676C15.3032 13.1818 14.3535 13.1818 13.7677 13.7676C13.1819 14.3534 13.1819 15.3031 13.7677 15.8889Z">
                                </path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="col-xl-3 col-md-6 mt-4">

            <div class="card ">
                <div class="card-body">
                    <div class="d-flex align-items-center">
                        <div class="flex-grow-1 ">
                            <p class="text-uppercase fw-medium text-muted  mb-0">{{placeHolders['LBL_MONEY_SPEND']}}</p>
                        </div>

                    </div>
                    <div class="d-flex align-items-end justify-content-between mt-4">
                        <div>
                            <h4 class="fs-22 fw-semibold ff-secondary mb-4">{{money_spend}}</h4>

                        </div>
                        <div class=" flex-shrink-0">
                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="3em" height="3em"
                                fill="rgba(135,138,155,1)">
                                <path
                                    d="M19.3788 15.1057C20.9258 11.4421 19.5373 7.11431 16.0042 5.0745C13.4511 3.60046 10.4232 3.69365 8.03452 5.0556L7.04216 3.31879C10.028 1.61639 13.8128 1.4999 17.0042 3.34245C21.4949 5.93513 23.2139 11.4848 21.1217 16.112L22.4635 16.8867L18.2984 19.1008L18.1334 14.3867L19.3788 15.1057ZM4.62961 8.89968C3.08263 12.5633 4.47116 16.8911 8.00421 18.9309C10.5573 20.4049 13.5851 20.3118 15.9737 18.9499L16.9661 20.6867C13.9803 22.389 10.1956 22.5055 7.00421 20.663C2.51357 18.0703 0.794565 12.5206 2.88672 7.89342L1.54492 7.11873L5.70999 4.90463L5.87505 9.61873L4.62961 8.89968ZM8.50421 14.0027H14.0042C14.2804 14.0027 14.5042 13.7788 14.5042 13.5027C14.5042 13.2266 14.2804 13.0027 14.0042 13.0027H10.0042C8.6235 13.0027 7.50421 11.8834 7.50421 10.5027C7.50421 9.122 8.6235 8.00271 10.0042 8.00271H11.0042V7.00271H13.0042V8.00271H15.5042V10.0027H10.0042C9.72807 10.0027 9.50421 10.2266 9.50421 10.5027C9.50421 10.7788 9.72807 11.0027 10.0042 11.0027H14.0042C15.3849 11.0027 16.5042 12.122 16.5042 13.5027C16.5042 14.8834 15.3849 16.0027 14.0042 16.0027H13.0042V17.0027H11.0042V16.0027H8.50421V14.0027Z">
                                </path>
                            </svg>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

    <div class="row mb-5 mt-5">
        <div class="col-lg-12">
            <div class="card" id="orderList">
                <div class="card-body border border-dashed border-end-0 border-start-0">
                    <form action="#">
                        <div class="row my-2 d-flex align-items-center">
                            <div class="col-xxl-6 col-sm-8 col-6 ">
                                <div>
                                    <span class=" text-dark">{{placeHolders['LBL_CATEGORY']}}</span>
                                    <select class="form-control" #categorySelect
                                        (change)="onCategoryChange(categorySelect.value)">
                                        <option *ngFor="let cat of allCategory" [value]="cat.category_id">
                                            {{ cat.category_type }}
                                        </option>
                                    </select>


                                </div>
                            </div>

                            <div class="col-xxl-4 col-sm-4 col-6 ">
                                <div>
                                    <span class="text-dark">{{placeHolders['LBL_STATUS']}}</span>
                                    <select class="form-control" [(ngModel)]="status" [ngModelOptions]="{standalone: true}">
                                        <option *ngFor="let item of statusList" [value]="item.value">
                                            {{ item.status }}
                                        </option>
                                    </select>
                                </div>
                            </div>

                            <div class="col-xxl-2 col-12">
                                <div>
                                    <button type="button" class="btn btn-info filter_btn text-white"
                                        (click)="getReportList()">
                                        {{placeHolders['LBL_FILTERS']}}
                                    </button>
                                </div>
                            </div>
                        </div>

                    </form>


                </div>
                <div class="card-body">
                    <div class="mt-2">


                        <div class="table-responsive table-card mb-0 mt-4" *ngIf="!no_data">
                            <table class="table">
                                <thead class="py-3">
                                    <tr class="bg-light text-muted text-uppercase">
                                        <th>{{placeHolders['TBL_LBL_NO']}}</th>
                                        <th>{{placeHolders['TBL_LBL_DEAL_TITLE']}}</th>
                                        <th>{{placeHolders['TBL_LBL_CATEGORY']}}</th>
                                        <th>{{placeHolders['LBL_STATUS']}}</th>
                                        <th>{{placeHolders['TBL_LBL_START_DATE']}}</th>
                                        <th>{{placeHolders['TBL_LBL_END_DATE']}}</th>
                                        <th>{{placeHolders['TBL_LBL_BUDGET']}}($)</th>
                                        <th>{{placeHolders['TBL_LBL_MONEY_SPEND']}}($)</th>

                                    </tr>


                                </thead>
                                <tbody>
                                    <tr *ngFor="let campaign of allReportData; let i = index" class="py-3">
                                        <td>{{ campaign.campaign_id }}</td>
                                        <td>
                                            <a routerLink="/reports/detailedReport/{{ campaign.campaign_id }}"
                                                class="text-decoration-none text_link">
                                                {{ campaign.campaign_name }}
                                            </a>
                                        </td>
                                        <td><span class="badge bg-soft-primary text-uppercase">{{
                                                campaign.categories[0]?.category_type }}</span></td>
                                        <td>
                                            <span class="badge text-uppercase" [ngClass]="{
                                          'bg-success-subtle text-success': campaign.status === 'ACTIVE',
                                          'bg-danger-subtle text-danger': campaign.status !== 'ACTIVE'
                                        }">
                                                {{ campaign.status }}
                                            </span>
                                        </td>

                                        <td>{{ campaign.start_date }}</td>
                                        <td>{{ campaign.end_date }}</td>
                                        <td>$ {{ campaign.budget }}</td>
                                        <td>$ {{ campaign.spent }}</td>
                                    </tr>


                                </tbody>
                            </table>

                        </div>
                        <div class="row mt-2" *ngIf="!no_data">
                            <div class="col-lg-3 col-md-6 col-6">
                                <div class="text-sm-left float-start">
                                    <label class="d-flex align-items-center">{{placeHolders['LBL_SHOWING']}} {{ (currentPage - 1) * pageSize + 1 }} {{placeHolders['LBL_TO']}} {{ currentPage * pageSize < totalCount ? currentPage * pageSize :
                                        totalCount }} {{placeHolders['LBL_OF']}} {{ totalCount }} {{placeHolders['LBL_ENTRIES']}}</label>
                                </div>
                            </div>
                            <div class="col-lg-9 col-md-6 col-6 ml-auto mr-auto">
                                <div class="text-sm-right float-end listjs-pagination">
                                    <app-pagination [totalRecords]="totalCount" [recordsPerPage]="pageSize"
                                        (onPageChange)="onPageChange($event)"></app-pagination>
                                </div>
                            </div>
                        </div>


                        <div class="row mt-2 text-center" *ngIf="no_data">
                            <h5>{{placeHolders['LBL_NO_RECORDS']}}</h5>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>



    <!-- <div class="div-42">Reports</div>
        <div class="div-43">
            <div class="div-44">
                <div class="div-45">
                    <div class="div-46">
                        <input type="search" autocomplete="off" maxlength="20" class=""
                            style="border:none; background-color: transparent ;" name="focus"
                            (click)="searchClick($event)" (keyup)="quickSearch($event)" placeholder="  Search" />
                    </div>
                    <img loading="lazy"
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/960e3587b102d32ae26b055144ae7805805584175a9f8744d348d759c2ad8f5e?"
                        class="img-19" />
                </div>
            </div>
            <div class="div-47">
                <img loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/67410ecd28e542fc77d1ec58dd6b5b5bad9785f1a076cde8b71bcc022f28a5b1?"
                    class="img-20" (click)="filterScreen()" />
            </div>
        </div> -->

    <!-- <div class="mt-2" *ngIf="allReportData.length!==0">
        <ag-grid-angular style="width: 100%;" class="ag-theme-quartz" [rowData]="allReportData"
            [gridOptions]="gridOptions" [suppressDragLeaveHidesColumns]="true" [columnDefs]="columnDefs"
            [animateRows]="true" [pagination]="false" (gridReady)="onGridReady($event)" domLayout='autoHeight'>
        </ag-grid-angular>


        <div class="row mt-2">
            <div class="col-5 ml-auto mr-auto">

            </div>
            <div class="col-7 ml-auto mr-auto">
                
                <app-pagination [totalRecords]="allReportData.length" [recordsPerPage]="10"
                    (onPageChange)="displayActivePage($event)"></app-pagination>
              
            </div>
        </div>

    - <div class="div-49">
            <mat-checkbox class="example-margin"></mat-checkbox>
            
        </div>
        <div class="div-51">
            <div class="div-52">Campaign Name</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/18372a5352462b4859bf1353660ae0dd76d74934bce6ef71a1dbf40803663bb3?"
                class="img-21" />
        </div>
        <div class="div-53">
            <div class="div-54">Campaign ID</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/18372a5352462b4859bf1353660ae0dd76d74934bce6ef71a1dbf40803663bb3?"
                class="img-22" />
        </div>
        <div class="div-55">
            <div class="div-56">Start Date</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/18372a5352462b4859bf1353660ae0dd76d74934bce6ef71a1dbf40803663bb3?"
                class="img-23" />
        </div>
        <div class="div-57">
            <div class="div-58">End Date</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/18372a5352462b4859bf1353660ae0dd76d74934bce6ef71a1dbf40803663bb3?"
                class="img-24" />
        </div>
        <div class="div-59">
            <div class="div-60">Status</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/18372a5352462b4859bf1353660ae0dd76d74934bce6ef71a1dbf40803663bb3?"
                class="img-25" />
        </div>
        <div class="div-61">
            <div class="div-62">Budget</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/18372a5352462b4859bf1353660ae0dd76d74934bce6ef71a1dbf40803663bb3?"
                class="img-26" />
        </div>
        <div class="div-63">
            <div class="div-64">Actual Spent</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/18372a5352462b4859bf1353660ae0dd76d74934bce6ef71a1dbf40803663bb3?"
                class="img-27" />
        </div>
        <div class="div-65">Action</div>
    </div> -->
    <!-- <div class="col-12 d-flex div-66 ">
        <div class="div-67">
           
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-69">Puma new season sale</div>
        <div class="div-70">CPGN4684</div>
        <div class="div-71">11/03/2023</div>
        <div class="div-72">11/03/2023</div>
        <div class="div-73">
            <div class="div-74">
                <div class="div-75">Active</div>
                <div class="div-76"></div>
            </div>
        </div>
        <div class="div-77">$1000.00</div>
        <div class="div-78">
            <div class="div-79">$600.00</div>
            <div class="div-80">60%</div>
        </div>
        <div class="div-81">
            <div class="div-82" (click)="view()">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-28" />
        </div>
    </div>
    <div class="div-83">
        <div class="div-84">
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-86">Puma new season sale</div>
        <div class="div-87">CPGN4684</div>
        <div class="div-88">11/03/2023</div>
        <div class="div-89">11/03/2023</div>
        <div class="div-90">
            <div class="div-91">
                <div class="div-92">Active</div>
                <div class="div-93"></div>
            </div>
        </div>
        <div class="div-94">$1000.00</div>
        <div class="div-95">
            <div class="div-96">$600.00</div>
            <div class="div-97">60%</div>
        </div>
        <div class="div-98">
            <div class="div-99">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-29" />
        </div>
    </div>
    <div class="div-100">
        <div class="div-101">
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-103">Puma new season sale</div>
        <div class="div-104">CPGN4684</div>
        <div class="div-105">11/03/2023</div>
        <div class="div-106">11/03/2023</div>
        <div class="div-107">
            <div class="div-108">
                <div class="div-109">Active</div>
                <div class="div-110"></div>
            </div>
        </div>
        <div class="div-111">$1000.00</div>
        <div class="div-112">
            <div class="div-113">$600.00</div>
            <div class="div-114">60%</div>
        </div>
        <div class="div-115">
            <div class="div-116">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-30" />
        </div>
    </div>
    <div class="div-117">
        <div class="div-118">
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-120">Puma new season sale</div>
        <div class="div-121">CPGN4684</div>
        <div class="div-122">11/03/2023</div>
        <div class="div-123">11/03/2023</div>
        <div class="div-124">
            <div class="div-125">
                <img loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/348a751f501739e889992dbb240e6ce9e2b9e47b5cce62142e4d1b86145b17f4?"
                    class="img-31" />
                <div class="div-126">Paused</div>
            </div>
        </div>
        <div class="div-127">$1000.00</div>
        <div class="div-128">
            <div class="div-129">$600.00</div>
            <div class="div-130">60%</div>
        </div>
        <div class="div-131">
            <div class="div-132">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-32" />
        </div>
    </div>
    <div class=" col-12 d-flex div-66">
        <div class="div-134 ">
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-136">Puma new season sale</div>
        <div class="div-137">CPGN4684</div>
        <div class="div-138">11/03/2023</div>
        <div class="div-139">11/03/2023</div>
        <div class="div-140">
            <div class="div-141">
                <img loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/348a751f501739e889992dbb240e6ce9e2b9e47b5cce62142e4d1b86145b17f4?"
                    class="img-33" />
                <div class="div-142">Paused</div>
            </div>
        </div>
        <div class="div-143">$1000.00</div>
        <div class="div-144">
            <div class="div-145">$600.00</div>
            <div class="div-146">60%</div>
        </div>
        <div class="div-147">
            <div class="div-148">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-34" />
        </div>
    </div>
    <div class="div-149">
        <div class="div-150">
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-152">Puma new season sale</div>
        <div class="div-153">CPGN4684</div>
        <div class="div-154">11/03/2023</div>
        <div class="div-155">11/03/2023</div>
        <div class="div-156">
            <div class="div-157">
                <div class="div-158"></div>
                <div class="div-159">Inactive</div>
            </div>
        </div>
        <div class="div-160">$1000.00</div>
        <div class="div-161">
            <div class="div-162">$600.00</div>
            <div class="div-163">60%</div>
        </div>
        <div class="div-164">
            <div class="div-165">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-35" />
        </div>
    </div>
    <div class="div-166">
        <div class="div-167">
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-169">Puma new season sale</div>
        <div class="div-170">CPGN4684</div>
        <div class="div-171">11/03/2023</div>
        <div class="div-172">11/03/2023</div>
        <div class="div-173">
            <div class="div-174">
                <div class="div-175"></div>
                <div class="div-176">Inactive</div>
            </div>
        </div>
        <div class="div-177">$1000.00</div>
        <div class="div-178">
            <div class="div-179">$600.00</div>
            <div class="div-180">60%</div>
        </div>
        <div class="div-181">
            <div class="div-182">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-36" />
        </div>
    </div>
    <div class="div-183">
        <div class="div-184">
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-186">Puma new season sale</div>
        <div class="div-187">CPGN4684</div>
        <div class="div-188">11/03/2023</div>
        <div class="div-189">11/03/2023</div>
        <div class="div-190">
            <div class="div-191">
                <img loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/8585a121130b4f4f34f4fff7d08e79aebc09031ba8a2a261276e4fd619bfc037?"
                    class="img-37" />
                <div class="div-192">Expired</div>
            </div>
        </div>
        <div class="div-193">$1000.00</div>
        <div class="div-194">
            <div class="div-195">$600.00</div>
            <div class="div-196">60%</div>
        </div>
        <div class="div-197">
            <div class="div-198">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-38" />
        </div>
    </div>
    <div class="div-199">
        <div class="div-200">
            <mat-checkbox class="example-margin">
            </mat-checkbox>
        </div>
        <div class="div-202">Puma new season sale</div>
        <div class="div-203">CPGN4684</div>
        <div class="div-204">11/03/2023</div>
        <div class="div-205">11/03/2023</div>
        <div class="div-206">
            <div class="div-207">
                <img loading="lazy"
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/8585a121130b4f4f34f4fff7d08e79aebc09031ba8a2a261276e4fd619bfc037?"
                    class="img-39" />
                <div class="div-208">Expired</div>
            </div>
        </div>
        <div class="div-209">$1000.00</div>
        <div class="div-210">
            <div class="div-211">$600.00</div>
            <div class="div-212">60%</div>
        </div>
        <div class="div-213">
            <div class="div-214">View</div>
            <img loading="lazy"
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/327d5d7e02368d20781ae4f8671867134f1389b5aabb39ed97b4c08663879c66?"
                class="img-40" />
        </div>
    </div> -->
    <!-- <div class="div-215">
        <img loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/aea2d4e3452b45654cf8851efbfb10ea2b1195533d04e3a0b5fae9e55f710fb5?"
            class="img-41" />
        <div class="div-216">1</div>
        <div class="div-217">2</div>
        <div class="div-218">...</div>
        <div class="div-219">9</div>
        <div class="div-220">10</div>
        <img loading="lazy"
            src="https://cdn.builder.io/api/v1/image/assets/TEMP/97c11d44bb1412f1f1e3ff86d18c68a28eb7fe5f2a6ba916c9d52809620272d1?"
            class="img-42" />
    </div> -->
    <!-- </div> -->
</form>